import ctaEventBus from '../ctaEventBus.js'

export default function handleHashLink(event, linkElement) {
  if (linkElement && linkElement.href) {
    const url = new URL(linkElement.href)
    const isSamePage =
      url.origin === window.location.origin &&
      url.pathname === window.location.pathname

    if (isSamePage && url.hash) {
      // We emit the event so hash links can be used to open modals (useful inside RichText)
      ctaEventBus.$emit(url.hash.substring(1))
    }
  }
}
